{
  "post_payment": {
    "step_1_title": "First we need some info about you",
    "step_1_description": "In order to get the most out of Vocalise, get started with telling us a little about yourself so we can help you succeed.",
    "step_1_cta": "Get started",
    "voice_type": "Voice type",
    "exercise_frequency": "How many times a week do you want to exercise?",
    "knowledge_level": "Knowledge level",
    "notes_label": "Anything else you’d like to add? (Optional)",
    "notes_placeholder": "Enter your text here",
    "step_2_cta": "Complete onboarding",
    "step_2_cta_next": "Next",
    "voice_types": {
      "soprano": "Soprano",
      "mezzo_soprano": "Mezzo-Soprano",
      "alto_contralto": "Alto / Contralto",
      "tenor": "Tenor",
      "baritone": "Baritone",
      "bass": "Bass",
      "unknown": "I do not know"
    },
    "knowledge_levels": {
      "beginner": "Beginner",
      "intermediate": "Intermediate",
      "advanced": "Advanced"
    }
  },
  "voice_assessment": {
    "page_title": "Vocalise Voice Assessment",
    "title": "Voice assessment",
    "description": "Each measurement helps build a clearer picture of your vocal progress.",
    "what_to_expect_heading": "What to expect:",
    "step_1": "Check-in on how your voice is feeling",
    "step_2": "Complete a set of measurements. Each followed by a quick reflection.",
    "step_2_standalone_one": "Complete one measurement. Followed by a quick reflection.",
    "step_2_standalone_other": "Complete {{count}} measurements. Each followed by a quick reflection.",
    "step_3": "A final reflection on the full assessment",
    "duration": "Takes about 5 minutes",
    "duration_about": "Takes about {{duration}}",
    "later_quiet_title": "Take it when you are ready",
    "later_quiet_note": "You do not need to do this now. Skip it and come back when you have time and are in a quiet environment.",
    "start_cta": "Start voice assessment",
    "skip_cta": "Skip for now",
    "skip_header": "Abort",
    "header_measurement_recording": "Measurement {{current}}: Recording",
    "header_measurement_questions": "Measurement {{current}}: Questions",
    "header_named_measurement_recording": "{{name}}: Recording",
    "header_named_measurement_questions": "{{name}}: Questions",
    "header_reflection": "Reflection",
    "measurement_recording_title": "Measurement {{current}} of {{total}}",
    "recording_instructions_title": "Get ready to record",
    "recording_instructions": {
      "quiet_environment": "Make sure you're in a quiet environment for the best results",
      "posture": "Stand comfortably with your knees slightly unlocked and relax your shoulders",
      "breath": "Take a deep breath before you begin",
      "voice": "Sing along with the exercise. Keep going until it feels like a stretch, but never painful",
      "listen": "Listen to the piano play the melody once, then join in and follow along with the track"
    },
    "recording_instructions_cta": "Got it!",
    "complete_assessment_cta": "Complete voice assessment",
    "leave_session_title": "Leave voice assessment?",
    "leave_session_message": "You will not be able to continue this voice assessment after leaving.",
    "leave_session_continue": "Continue voice assessment",
    "leave_session_leave": "Leave",
    "finish_heading": "Well done {{name}}.",
    "finish_subheading": "Voice assessment finished!",
    "upload_failed_title": "Voice assessment upload failed",
    "upload_failed_message": "Tap retry to send it again.",
    "upload_missing_recordings_message": "We could not find your recordings. Confirm each recording before completing.",
    "load_definition_failed_title": "Voice assessment unavailable",
    "load_definition_failed_message": "We couldn't load the assessment setup. Check your connection and try again.",
    "start_session_failed_message": "We could not start the assessment. Please try again.",
    "no_measurements_message": "This assessment has no measurements configured.",
    "submit_success_title": "Voice assessment submitted",
    "submit_success_message": "Your recording is being analyzed. Results will appear in Statistics when ready."
  },
  "record": {
    "title": "Record your voice",
    "subtitle": "Listen to the piano and sing along",
    "ready_instruction": "Listen to the piano only, or start recording and sing along.",
    "play_piano": "Play piano notes",
    "play_example": "Play example",
    "playing_piano": "Playing piano notes...",
    "playing_example": "Playing example...",
    "start_recording": "Start recording",
    "recording_status": "Recording...",
    "elapsed_recording": "Recording time: {{seconds}}s",
    "stop_recording": "Stop recording",
    "succeeded_status": "Recording succeeded",
    "listen_to_recording": "Listen to recording",
    "stop_playback": "Stop playback",
    "redo_recording": "Redo recording",
    "quiet_tip": "Make sure you're in a quiet environment for the best results.",
    "helper_action_failed": "We could not play the audio helper. Please try again.",
    "piano_helper_action_failed": "We could not play the piano notes. Please try again.",
    "example_helper_action_failed": "We could not play the example audio. Please try again.",
    "retry_helper_action": "Retry",
    "permission_required": "Microphone permission is required to record your voice.",
    "start_recording_failed": "Could not start recording. Please try again.",
    "stop_recording_failed": "Could not stop recording. Please try again.",
    "playback_failed": "Could not play your recording. Please try again."
  },
  "reflection": {
    "tension_location_instruction": "Select all options that apply",
    "personal_reflection_title": "Personal reflection",
    "personal_reflection_prompt": "Reflect on what you experienced during the exercise. What did you notice? What felt good or challenging? Any insights or questions?"
  },
  "check_in": {
    "next_cta": "Next"
  }
}
